<template>
  <div class="admin-layout">
    <AdminSidebar @toggle="onSidebarToggle" />
    <div class="admin-body">
      <AdminTopBar />
      <main class="admin-content">
        <router-view />
      </main>
    </div>
    <SetupWizard />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import AdminSidebar from './AdminSidebar.vue'
import AdminTopBar from './AdminTopBar.vue'
import SetupWizard from './admin/SetupWizard.vue'

const sidebarCollapsed = ref(false)

function onSidebarToggle(collapsed: boolean) {
  sidebarCollapsed.value = collapsed
}
</script>

<style scoped>
.admin-layout {
  display: flex;
  height: 100vh;
  overflow: hidden;
  background: var(--bg-primary, #0f1923);
  color: var(--text-primary, #fff);
}

.admin-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;
}

.admin-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}

.admin-content :deep(.view) {
  padding: 24px;
  animation: fadeUp 0.3s ease both;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Custom scrollbar */
.admin-content::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

.admin-content::-webkit-scrollbar-track {
  background: var(--bg-primary, #0f1923);
}

.admin-content::-webkit-scrollbar-thumb {
  background: var(--bg-tertiary, #213743);
  border-radius: 4px;
}

/* Responsive: sidebar collapses at <768px */
@media (max-width: 768px) {
  .admin-layout {
    flex-direction: column;
  }

  .admin-body {
    flex: 1;
  }
}
</style>
